export const Types = {
  "dintero-payments": {
    label: "Betalning: Dintero",
    component: "integrations-form-dintero-payments"
  },
  "briqpay-payments": {
    label: "Betalning: Briqpay",
    component: "integrations-form-briqpay-payments"
  },
  "svea-checkout-payments": {
    label: "Betalning: Svea Checkout",
    component: "integrations-form-svea-checkout-payments"
  },
  "swish-recurring-payments": {
    label: "Betalning: Swish Recurring",
    component: "integrations-form-swish-recurring-payments"
  },
  "zaver-payments": {
    label: "Betalning: Zaver",
    component: "integrations-form-zaver-payments"
  },
  "klarna-checkout-payments": {
    label: "Betalning: Klarna Checkout",
    component: "integrations-form-klarna-checkout-payments"
  },
  "shopify-checkout-payments": {
    label: "Betalning: Shopify Checkout",
    component: "integrations-form-shopify-checkout-payments"
  },
  "woocommerce-link-payments": {
    label: "Betalning: Woocommerce Länk",
    component: "integrations-form-woocommerce-link-payments"
  },
  "checkout-webhook-generic": {
    label: "Checkout Webhook: Generell",
    component: "integrations-form-checkout-webhook-generic"
  },
  "checkout-webhook-google-ads": {
    label: "Checkout Webhook: Google Ads",
    component: "integrations-form-checkout-webhook-google-ads"
  },
  "checkout-webhook-google-ads-enhanced": {
    label: "Checkout Webhook: Google Ads Enhanced (Backend)",
    component: "integrations-form-checkout-webhook-google-ads-enhanced"
  },
  "checkout-webhook-meta": {
    label: "Checkout Webhook: Meta",
    component: "integrations-form-checkout-webhook-meta"
  },
  "checkout-webhook-meta-advanced-matching": {
    label: "Checkout Webhook: Meta Advanced Matching (CAPI)",
    component: "integrations-form-checkout-webhook-meta-advanced-matching"
  },
  "checkout-webhook-raddningsmissionen": {
    label: "Checkout Webhook: Räddningsmissionen",
    component: "integrations-form-checkout-webhook-raddningsmissionen"
  },
  "checkout-webhook-profundo": {
    label: "Checkout Webhook: Profundo",
    component: "integrations-form-checkout-webhook-profundo"
  },
  "checkout-webhook-callmaker": {
    label: "Checkout Webhook: Callmaker",
    component: "integrations-form-checkout-webhook-callmaker"
  },
  "checkout-webhook-adversus": {
    label: "Checkout Webhook: Adversus",
    component: "integrations-form-checkout-webhook-adversus"
  },
  "checkout-webhook-bris": {
    label: "Checkout Webhook: Bris",
    component: "integrations-form-checkout-webhook-bris"
  },
  "incoming-webhook-create-brandawareness": {
    label: "Ingående Webhook: Skapa mötesinbjudan & visitkort",
    component: "integrations-form-incoming-webhook-create-brandawareness"
  },
  "incoming-webhook-create-quote": {
    label: "Ingående Webhook: Skapa offert",
    component: "integrations-form-incoming-webhook-create-quote"
  },
  "incoming-webhook-create-quote-using-template": {
    label: "Ingående Webhook: Skapa med mall",
    component: "integrations-form-incoming-webhook-create-quote-using-template"
  },
  "incoming-webhook-create-quote-from-callmaker": {
    label: "Ingående Webhook: Skapa med Callmaker",
    component: "integrations-form-incoming-webhook-create-quote-from-callmaker"
  },
  "incoming-webhook-create-quote-from-adversus": {
    label: "Ingående Webhook: Skapa med Adversus",
    component: "integrations-form-incoming-webhook-create-quote-from-adversus"
  },
  "incoming-webhook-disable-automations": {
    label: "Ingående Webhook: Inaktivera automation",
    component: "integrations-form-incoming-webhook-disable-automations"
  },
  "incoming-webhook-woocommerce": {
    label: "Ingående Webhook: Woocommerce",
    component: "integrations-form-incoming-webhook-woocommerce"
  },
  "calendly-link-quotes": {
    label: "Calendly: Länka kunder till bokade möten",
    component: "integrations-form-calendly-link-quotes"
  },
  "calendly-embedded-calendar": {
    label: "Calendly: Inbäddad kalender",
    component: "integrations-form-calendly-embedded-calendar"
  },
  "billetto-embedded-widget": {
    label: "Billetto: Inbäddad Widget",
    component: "integrations-form-billetto-embedded-widget"
  },
  "billecta-bank-account-retrieval": {
    label: "Billecta: Hämta bankkonto",
    component: "integrations-form-billecta-bank-account-retrieval"
  },
  "brite-account-report": {
    label: "Brite: Hämta bankkonto",
    component: "integrations-form-brite-account-report"
  },
  "billecta-debtors": {
    label: "Billecta: Debtor",
    component: "integrations-form-billecta-debtors"
  },
  fortnox: {
    label: "Fortnox",
    component: "integrations-form-fortnox"
  },
  "ftp-quotes-export": {
    label: "FTP Erbjuder Export",
    component: "integrations-form-ftp-quotes-export"
  },
  hubspot: {
    label: "Hubspot",
    component: "integrations-form-hubspot"
  }
};
